/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["aside[_ngcontent-%COMP%]{z-index:100;cursor:progress;top:0;bottom:0;left:0;right:0}.background[_ngcontent-%COMP%]{background-color:#fff;opacity:.95;height:100%;width:100%;z-index:0}.rm-loader[_ngcontent-%COMP%]{max-width:200px}.loader-wrapper[_ngcontent-%COMP%]{z-index:1}"];
export { styles as styles };
